class NullAnalytics {
  sendEvent() {}
}

export default NullAnalytics;
